import {LogRocketAnalytics} from './analytics/logRocket';

export const analytics = new LogRocketAnalytics();
